module.exports = __webpack_public_path__ + "dbd9c3d5ab8444429b3d919f33687ed7.png";